/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */
import { enqueueSnackbar } from "notistack";
import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";


const createStaffMenus = async (user, data, logout, id) => {
    const storageAvailable = localStorageAvailable();

    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `/system/admin/menu/${id}`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data: data,
    };
    try {
        const response = await axios.request(config);
        return response;
    } catch (error) {
        console.log(error);

        if (error?.data === "Verification timeout") {
            return;
        }
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        enqueueSnackbar(error?.data?.message || error?.data, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default createStaffMenus;
